module.exports = __webpack_public_path__ + "img/wisdom_2.56502fad.png";